module.exports = __webpack_public_path__ + "static/media/price2023.21083a28.jpg";